module.exports = __webpack_public_path__ + "img/eos.3cd06402.svg";